import React, { useEffect, useContext } from "react";
const isBrowser = typeof window !== "undefined";
import PromotionDetailComponent from "components/PromotionDetail";
import Async from "components/Async/Async";
import langDataZH from "./../data/static-pages/pages/promotion/zh";
import langDataJA from "./../data/static-pages/pages/promotion/ja";
import langDataEN from "./../data/static-pages/pages/promotion/en";
import { getLang } from "../state/reducers/langSession";

const PromotionDetail = ({ ...props }) => {
  if (getLang() == "ja") {
    var langKey = langDataJA;
  } else if (getLang() == "zh") {
    var langKey = langDataZH;
  } else {
    var langKey = langDataEN;
  }

  return (
    <Async
      onSuccess={() => (
        <>
          <PromotionDetailComponent
            langData={langKey}
            promotion={props.data}
            homeUrl={props.homeUrl}
            promotionUrl={props.promotionUrl}
          />
        </>
      )}></Async>
  );
};

export default PromotionDetail;
